import { FC, ReactNode } from 'react';
import Sidebar from '@components/ui/Sidebar';

interface DefaultLayoutProps {
  children: ReactNode;
}

const DefaultLayout: FC<DefaultLayoutProps> = ({ children }) => {
  return (
    <div className="h-screen w-screen flex flex-row overflow-hidden">
      <Sidebar />
      <main className="bg-navy-100 p-6 flex-1 overflow-y-auto">{children}</main>
    </div>
  );
};

export default DefaultLayout;
